import axios from "axios";
import { fetchJWTToken } from "../utils/auth";
import { BASE_URL } from "../constants/Endpoints";
import { toast } from "react-toastify";

export function fetchStripeInvoiceList(data) {
  return axios({
    method: "GET",
    url: `${BASE_URL}/om/stripe-invoice/list?pageNumber=${
      data.pageNumber
    }&pageSize=${data.pageSize}&status=${data.status}`,
    headers: {
      Authorization: fetchJWTToken(),
    },
  });
}

export function getStripeInvoice(invoiceNumber) {
  return axios({
    method: "GET",
    url: `${BASE_URL}/om/stripe-invoice/${invoiceNumber}`,
    headers: {
      Authorization: fetchJWTToken(),
    },
  });
}

export function fetchStripeInvoiceDetails(invoiceNumber) {
  return axios({
    method: "GET",
    url: `${BASE_URL}/om/stripe-invoice?invoiceNumber=${invoiceNumber}`,
    headers: {
      Authorization: fetchJWTToken(),
    },
  });
}

export function fetchLastStripeInvoiceDetails() {
  return axios({
    method: "GET",
    url: `${BASE_URL}/om/stripe-invoice/last-billed-info`,
    headers: {
      Authorization: fetchJWTToken(),
    },
  });
}

export function createStripeInvoice(data) {
  return axios({
    method: "POST",
    url: `${BASE_URL}/om/stripe-invoice/create-send`,
    data: data,
    headers: {
      Authorization: fetchJWTToken(),
      "Content-Type": "application/json",
    },
  });
}

export function updateStripeInvoice(data) {
  return axios({
    method: "POST",
    url: `${BASE_URL}/om/stripe-invoice/create-send`,
    data: data,
    headers: {
      Authorization: fetchJWTToken(),
      "Content-Type": "application/json",
    },
  });
}

export function sendStripeInvoice(data) {
  return axios({
    method: "POST",
    url: `${BASE_URL}/om/stripe-invoice/send`,
    data: data,
    headers: {
      Authorization: fetchJWTToken(),
    },
  });
}

export function cancelStripeInvoice(invoiceNumber) {
  return axios({
    method: "PUT",
    url: `${BASE_URL}/om/stripe-invoice/cancel/${invoiceNumber}`,
    headers: {
      Authorization: fetchJWTToken(),
    },
  });
}

export function deleteStripeInvoice(invoiceNumber) {
  return axios({
    method: "DELETE",
    url: `${BASE_URL}/om/stripe-invoice/${invoiceNumber}`,
    headers: {
      Authorization: fetchJWTToken(),
    },
  });
}